// src/components/UI/Button.js
import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md',         
  className = '', 
  loading = false, // تم تغيير الاسم من isLoading ليتطابق مع ما ترسله في Profile.js
  isLoading,      // استلامها أيضاً للاحتياط إذا كنت تستخدمها في أماكن أخرى
  icon: Icon,
  ...props 
}) => {
  
  // دمج الحالتين لضمان العمل في كل الأحوال
  const activeLoading = loading || isLoading;

  const baseStyles = "inline-flex items-center justify-center font-medium transition-all duration-200 rounded-md focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed select-none whitespace-nowrap overflow-hidden";
  
  const variants = {
    primary: "bg-[var(--primary-color)] text-white hover:opacity-90 shadow-sm border border-transparent",
    secondary: "bg-[var(--secondary-color)] text-white hover:opacity-90",
    danger: "bg-[var(--danger-color)] text-white hover:opacity-90",
    success: "bg-[var(--success-color)] text-white hover:opacity-90",
    outline: "border border-[var(--primary-color)] text-[var(--primary-color)] hover:bg-[var(--primary-color)] hover:text-white"
  };

  const sizes = {
    sm: "h-8 px-3 text-xs gap-1.5",
    md: "h-10 px-4 text-sm gap-2",
    lg: "h-12 px-6 text-base font-bold gap-2",
    // Matches FloatingInput/SelectBox's own 56px border-box height exactly
    // (pt-6 + text-sm line-height + pb-2, or SelectBox's explicit
    // minHeight: "56px") — for a Button placed directly beside one of those
    // fields (e.g. EntityTranslationsButton) so the two sit at the same
    // height instead of the button looking short and low next to a tall
    // floating-label field.
    input: "h-14 px-4 text-sm gap-2"
  };

  const iconSize = size === 'sm' ? 14 : size === 'lg' ? 20 : 16;

  return (
    <button 
      // نضع الخصائص أولاً ثم نعدل الـ className والـ disabled
      // لضمان عدم تمرير loading للـ DOM
      {...props} 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={activeLoading || props.disabled}
    >
      {activeLoading ? (
        <span className="animate-spin flex-shrink-0 text-current">◌</span> 
      ) : Icon && (
        <span className="flex items-center justify-center flex-shrink-0">
           <Icon 
             style={{ width: iconSize, height: iconSize }}
             className="text-current"
           />
        </span>
      )}
      
      {children && <span className="truncate">{children}</span>}
    </button>
  );
};

export default Button;